import { render } from "./App.vue?vue&type=template&id=5d0b47ec"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5d0b47ec&lang=scss"
script.render = render

export default script